import React from 'react';
import './AccordionConnector.css';

const AccordionConnector = ({ connectorRef }) => {
  return (
    <div
      ref={connectorRef}
      className="accordion-to-details-connector"
      data-ready="false"
      data-animate="false"
      aria-hidden="true"
    >
      <div className="connector-line"></div>
    </div>
  );
};

export default AccordionConnector;

